// FlexiTech - Complete Website Mock Data

export const companyInfo = {
  name: "FlexiTech",
  tagline: "Professional IT Support for Australian Businesses",
  heroHeadline: "Reliable IT Support for Australian Businesses",
  heroSubheadline: "Professional, responsive, and secure IT services for medical centres, law firms, real estate agencies, and small businesses.",
  heroChecks: [
    "Over 20 years of experience",
    "Local Australian IT experts",
    "Fast response & proactive support",
  ],
  whatWeDo: "FlexiTech provides managed IT services and technical support that keep your business running smoothly. From day-to-day IT issues to complex infrastructure and cloud projects, we act as your trusted IT partner.",
  whatWeDoPoints: [
    "Proactive monitoring that catches issues before they impact you",
    "Responsive helpdesk support when you need it most",
    "Strategic IT planning aligned with your business goals",
    "Enterprise-grade security at small-business pricing",
  ],
  phone: "02 919 174 64",
  email: "info@flexitech.net.au",
  legalName: "Lilla Pty Ltd",
  abn: "75 642 552 421",
};

export const stats = [
  { value: "20+", label: "Years' IT Experience", icon: "Award" },
  { value: "10", label: "Core IT Services", icon: "Building2" },
  { value: "Free", label: "Initial Consultation", icon: "ThumbsUp" },
  { value: "Remote", label: "& On-site Support", icon: "Clock" },
];

export const trustSignals = [
  { label: "Australian Owned & Operated", icon: "Flag" },
  { label: "20+ Years' IT Experience", icon: "Award" },
  { label: "No Lock-In Contracts", icon: "Unlock" },
  { label: "Fast, Responsive Support", icon: "Zap" },
];

export const services = [
  {
    id: "managed-it-support",
    title: "Managed IT Support",
    seoTitle: "Managed IT Support & Helpdesk for Australian Businesses",
    icon: "Monitor",
    shortDesc: "We look after your entire IT environment so you don't have to. Think of us as your outsourced IT department — monitoring, maintaining, and supporting your systems every day.",
    description: "Our managed IT support gives your business a complete IT department without the overhead of hiring in-house. We proactively monitor your systems 24/7, handle day-to-day IT issues, and keep everything patched, updated, and secure — so you can focus on running your business.",
    features: [
      "Unlimited remote and onsite support",
      "Proactive monitoring and maintenance",
      "Patch management and updates",
      "Security management and threat protection",
      "Backup monitoring and validation",
      "Vendor and ISP liaison",
      "Dedicated account manager",
      "Monthly performance reporting",
    ],
    benefits: [
      { title: "Reduce Downtime", desc: "Proactive monitoring catches issues before they affect your business operations." },
      { title: "Fixed Monthly Cost", desc: "Predictable IT spending with no surprise bills — ever." },
      { title: "Your Own IT Team", desc: "Access a full team of IT professionals for less than the cost of one hire." },
    ],
  },
  {
    id: "microsoft-365-support",
    title: "Microsoft 365 Support",
    seoTitle: "Microsoft 365 (Office 365) Support & Administration in Australia",
    icon: "LayoutGrid",
    shortDesc: "Get the most out of Outlook, Teams, SharePoint, and the full Microsoft 365 suite. We handle setup, user management, security, and ongoing support so your team stays productive.",
    description: "Microsoft 365 is at the heart of most modern workplaces. We help you set it up properly, manage your users and licences, configure security policies, and provide ongoing support — so your team can collaborate seamlessly from anywhere.",
    features: [
      "Microsoft 365 deployment and configuration",
      "User management and licensing optimisation",
      "Teams and SharePoint administration",
      "Security and compliance configuration",
      "Training and adoption support",
      "Ongoing monitoring and optimisation",
    ],
    benefits: [
      { title: "Maximise ROI", desc: "Get full value from your Microsoft 365 licences." },
      { title: "Seamless Collaboration", desc: "Properly configured Teams and SharePoint for your workflows." },
      { title: "Enhanced Security", desc: "Properly configured security policies and compliance settings." },
    ],
  },
  {
    id: "email-migration",
    title: "Email Migration",
    seoTitle: "Email Migration Services for Australian Businesses",
    icon: "MailPlus",
    shortDesc: "Moving to a new email platform? We handle the entire migration — every mailbox, calendar, and contact — with zero data loss and minimal disruption to your workday.",
    description: "Migrating email doesn't have to be stressful. Whether you're moving from an old server to Microsoft 365, switching providers, or consolidating systems, we plan and execute the entire migration so nothing gets lost and your team barely notices the change.",
    features: [
      "Comprehensive migration planning",
      "Mailbox, calendar, and contact migration",
      "DNS and MX record management",
      "Post-migration testing and validation",
      "User training and documentation",
      "Legacy system decommissioning",
    ],
    benefits: [
      { title: "Zero Data Loss", desc: "Every email, contact, and calendar entry migrated safely." },
      { title: "Minimal Disruption", desc: "Carefully planned migrations that don't stop your business." },
      { title: "Full Support", desc: "Dedicated support throughout the entire migration process." },
    ],
  },
  {
    id: "server-support",
    title: "Server Support",
    seoTitle: "Server Support & Management for Small Businesses in Australia",
    icon: "Server",
    shortDesc: "Whether your servers are in the office, in a data centre, or in the cloud — we keep them healthy, secure, and running at peak performance so your business never skips a beat.",
    description: "Your servers are the backbone of your business. We install, monitor, maintain, and troubleshoot your server infrastructure — whether it's on-premises, hybrid, or fully cloud-based — so you get reliable performance and peace of mind.",
    features: [
      "Server installation and configuration",
      "Performance monitoring and optimisation",
      "Security patching and updates",
      "Backup configuration and testing",
      "Hardware lifecycle management",
      "Virtualisation management (Hyper-V, VMware)",
    ],
    benefits: [
      { title: "Peak Performance", desc: "Optimised servers that run efficiently and reliably." },
      { title: "Proactive Care", desc: "Issues identified and resolved before they cause downtime." },
      { title: "Extended Lifespan", desc: "Proper maintenance extends the life of your server hardware." },
    ],
  },
  {
    id: "active-directory-azure-ad",
    title: "Active Directory & Azure AD",
    seoTitle: "Active Directory & Azure AD Management for Australian Businesses",
    icon: "Users",
    shortDesc: "We set up and manage your user accounts, access permissions, and security policies — so the right people have access to the right systems, every time.",
    description: "Managing who has access to what in your business is critical for security and productivity. We design, implement, and manage Active Directory and Azure AD environments that keep your users organised and your data protected.",
    features: [
      "Active Directory design and implementation",
      "Azure AD and hybrid identity setup",
      "Group Policy management",
      "Single Sign-On (SSO) configuration",
      "Multi-Factor Authentication (MFA)",
      "User provisioning and deprovisioning",
    ],
    benefits: [
      { title: "Secure Access", desc: "Right people, right access, right time \u2014 every time." },
      { title: "Simplified Management", desc: "Streamlined user and device management across your organisation." },
      { title: "Compliance Ready", desc: "Identity policies that meet Australian compliance requirements." },
    ],
  },
  {
    id: "cybersecurity",
    title: "Cybersecurity",
    seoTitle: "Cybersecurity Solutions for Small Businesses in Australia",
    icon: "ShieldCheck",
    shortDesc: "Cyber threats are growing every day. We protect your business with multi-layered security — from endpoint protection and email filtering to staff training and incident response planning.",
    description: "Australian small businesses are increasingly targeted by cybercriminals. We implement comprehensive, multi-layered security that protects your data, your clients' data, and your reputation — without making your systems difficult to use.",
    features: [
      "Endpoint detection and response (EDR)",
      "Email security and anti-phishing",
      "Security awareness training",
      "Vulnerability assessments",
      "Firewall management",
      "Incident response planning",
      "Dark web monitoring",
    ],
    benefits: [
      { title: "Comprehensive Protection", desc: "Multi-layered security that covers all attack vectors." },
      { title: "Staff Awareness", desc: "Training that turns your team into your first line of defence." },
      { title: "Peace of Mind", desc: "Know your business data is protected against modern threats." },
    ],
  },
  {
    id: "backup-disaster-recovery",
    title: "Backup & Disaster Recovery",
    seoTitle: "Backup & Disaster Recovery Services for Australian Businesses",
    icon: "DatabaseBackup",
    shortDesc: "Your business data is your most valuable asset. We set up reliable, tested backups and disaster recovery plans so you can recover quickly from any data loss event.",
    description: "Hardware failures, ransomware attacks, and human error can all put your data at risk. We implement automated backup solutions, test them regularly, and create disaster recovery plans — so if the worst happens, you're back up and running fast.",
    features: [
      "Automated daily backups",
      "Cloud and on-premises backup options",
      "Regular backup testing and validation",
      "Disaster recovery planning",
      "Rapid data restoration",
      "Business continuity planning",
    ],
    benefits: [
      { title: "Data Protection", desc: "Your critical business data is safe and recoverable." },
      { title: "Rapid Recovery", desc: "Get back to business quickly after any data loss event." },
      { title: "Tested & Verified", desc: "Regular testing ensures your backups actually work." },
    ],
  },
  {
    id: "cloud-services",
    title: "Cloud Services (Azure)",
    seoTitle: "Cloud Services & Microsoft Azure Solutions for Australian Businesses",
    icon: "Cloud",
    shortDesc: "Ready to move to the cloud? We help you plan, migrate, and manage your cloud infrastructure on Microsoft Azure — so you get the flexibility and cost savings without the complexity.",
    description: "Cloud computing gives your business flexibility, scalability, and cost efficiency. We guide you through every step — from assessing your readiness and planning the migration, to managing your Azure environment and optimising your cloud spending.",
    features: [
      "Cloud readiness assessment",
      "Azure migration planning and execution",
      "Virtual machine and resource management",
      "Cost optimisation and monitoring",
      "Hybrid cloud configuration",
      "Azure security and compliance",
    ],
    benefits: [
      { title: "Scalable Infrastructure", desc: "Scale your IT resources up or down as your business needs change." },
      { title: "Cost Efficiency", desc: "Pay only for what you use with optimised cloud spending." },
      { title: "Modern Platform", desc: "Access the latest technology without heavy capital investment." },
    ],
  },
  {
    id: "network-infrastructure",
    title: "Network & Infrastructure",
    seoTitle: "Network & IT Infrastructure Services for Australian Businesses",
    icon: "Network",
    shortDesc: "A slow or unreliable network costs your business time and money. We design, deploy, and manage robust networks that keep your team connected and productive — in the office and remotely.",
    description: "Your network is the foundation everything else runs on. We design and build reliable, secure network infrastructure — from Wi-Fi and cabling to firewalls and VPNs — that keeps your team connected whether they're in the office, working from home, or across multiple sites.",
    features: [
      "Network design and architecture",
      "Wireless network deployment",
      "Firewall and security appliances",
      "VPN and remote access solutions",
      "Network monitoring and management",
      "Cabling and physical infrastructure",
    ],
    benefits: [
      { title: "Reliable Connectivity", desc: "A network that keeps your team connected without interruption." },
      { title: "Secure By Design", desc: "Security built into your network architecture from the ground up." },
      { title: "Scalable Design", desc: "Infrastructure that grows with your business." },
    ],
  },
  {
    id: "it-consulting-projects",
    title: "IT Consulting & Projects",
    seoTitle: "IT Consulting & Project Management for Small Businesses in Australia",
    icon: "Lightbulb",
    shortDesc: "Making a big technology decision? We provide expert, independent advice and manage IT projects from start to finish — office moves, system upgrades, new technology rollouts, and more.",
    description: "Whether you're planning an office move, upgrading your systems, or trying to figure out where your IT budget should go, we provide clear, independent guidance. Our consultants have decades of experience helping Australian businesses make smart technology decisions.",
    features: [
      "IT strategy and roadmap development",
      "Technology audits and assessments",
      "Project planning and management",
      "Vendor selection and management",
      "Office moves and fit-outs",
      "Technology budgeting and forecasting",
    ],
    benefits: [
      { title: "Strategic Alignment", desc: "Technology decisions that support your business objectives." },
      { title: "Expert Guidance", desc: "Experienced consultants who've seen it all before." },
      { title: "Informed Decisions", desc: "Data-driven recommendations for your technology investments." },
    ],
  },
];

export const industries = [
  {
    id: "medical-centres",
    title: "Medical Centres",
    seoTitle: "IT Support for Medical Centres & Healthcare Providers in Australia",
    icon: "Stethoscope",
    shortDesc: "We understand healthcare IT. From patient data security and compliance to practice management software support, we keep your medical centre running safely and efficiently.",
    description: "Medical centres have unique IT needs — strict data privacy requirements, critical uptime for patient bookings, and complex software integrations. FlexiTech has over a decade of experience supporting Australian medical practices, and we understand the technology that keeps your clinic running.",
    challenges: [
      "Protecting sensitive patient health records",
      "Maintaining compliance with Australian health data regulations",
      "Ensuring uptime for critical practice management systems",
      "Integrating medical devices and software",
      "Supporting telehealth and remote consultations",
    ],
    solutions: [
      "Australian Privacy Act compliant infrastructure",
      "Best Practice, Medical Director, and clinical software support",
      "Secure patient data backup and disaster recovery",
      "Telehealth platform setup and support",
      "Medical device network integration",
    ],
  },
  {
    id: "law-firms",
    title: "Law Firms",
    seoTitle: "IT Support for Law Firms & Legal Practices in Australia",
    icon: "Scale",
    shortDesc: "Client confidentiality is non-negotiable. We provide secure, reliable IT that protects sensitive legal data while keeping your practice management systems running smoothly.",
    description: "Law firms handle highly sensitive client information every day. You need IT that's rock-solid reliable, completely secure, and managed by people who understand legal industry requirements. FlexiTech has been the trusted IT partner for Australian law firms for over 15 years.",
    challenges: [
      "Protecting confidential client information",
      "Meeting legal industry compliance requirements",
      "Ensuring document management system reliability",
      "Supporting remote and flexible working",
      "Managing large volumes of sensitive documents",
    ],
    solutions: [
      "Encrypted communication and data storage",
      "LEAP, SILQ, and practice management software support",
      "Secure remote access and VPN solutions",
      "Document management system integration",
      "Advanced email security and anti-phishing protection",
    ],
  },
  {
    id: "real-estate-agencies",
    title: "Real Estate Agencies",
    seoTitle: "IT Support for Real Estate Agencies in Australia",
    icon: "Building2",
    shortDesc: "Your agents are always on the move. We set up and manage IT that works seamlessly across the office, at home, and out in the field — keeping deals flowing and data secure.",
    description: "Real estate is fast-paced, and your technology needs to keep up. FlexiTech supports real estate agencies with reliable connectivity for mobile agents, seamless CRM integrations, and multi-site office networks — so your team can close deals from anywhere.",
    challenges: [
      "Supporting mobile and remote agents",
      "Integrating CRM and property management platforms",
      "Maintaining reliable connectivity across offices",
      "Protecting client transaction data",
      "Managing multiple office locations",
    ],
    solutions: [
      "Mobile device management for field agents",
      "CRM and property platform integration",
      "Multi-site network management",
      "Cloud-based solutions for anywhere access",
      "Reliable communication systems setup",
    ],
  },
  {
    id: "accounting-firms",
    title: "Accounting Firms",
    seoTitle: "IT Support for Accounting Firms & Financial Practices in Australia",
    icon: "Calculator",
    shortDesc: "During tax season, every minute of downtime costs money. We ensure your accounting software, financial data, and systems are always secure, backed up, and performing at their best.",
    description: "Accounting firms handle sensitive financial data and depend on critical software like Xero and MYOB. Downtime during tax season isn't an option. FlexiTech provides reliable, proactive IT support that keeps your practice running smoothly year-round — especially when it matters most.",
    challenges: [
      "Securing sensitive financial client data",
      "Supporting critical tax season workloads",
      "Managing accounting software integrations",
      "Meeting financial industry compliance standards",
      "Ensuring reliable performance during peak periods",
    ],
    solutions: [
      "Xero, MYOB, and accounting software support",
      "Tax season infrastructure scaling",
      "ATO and compliance-ready security configurations",
      "Automated backup for financial records",
      "High-availability systems for peak periods",
    ],
  },
  {
    id: "small-businesses",
    title: "Small Businesses",
    seoTitle: "IT Support for Small Businesses in Australia",
    icon: "Briefcase",
    shortDesc: "You shouldn't need a big budget to get great IT support. We provide enterprise-level technology management at pricing designed specifically for small and growing Australian businesses.",
    description: "Small businesses are the backbone of Australia, and they deserve IT support that's professional, affordable, and actually helpful. FlexiTech gives you access to a full team of IT experts — proactive monitoring, security, helpdesk support, and strategic guidance — without the enterprise price tag.",
    challenges: [
      "Limited IT budget and resources",
      "No dedicated in-house IT staff",
      "Need for reliable, always-on technology",
      "Growing pains as the business scales",
      "Keeping up with cybersecurity threats",
    ],
    solutions: [
      "Flexible, scalable support plans",
      "Virtual CTO services and IT guidance",
      "Cost-effective cloud and productivity solutions",
      "Proactive security for small business budgets",
      "Technology roadmap planning for growth",
    ],
  },
];

export const whyChooseReasons = [
  {
    title: "20+ Years of Hands-On Experience",
    description: "Two decades solving real IT problems for Australian businesses. We've seen it all, fixed it all, and learned from it all.",
    icon: "Award",
  },
  {
    title: "Australian-Based Local Support",
    description: "We're a local business supporting local businesses. No offshore call centres — just real people in Australia who understand your needs.",
    icon: "MapPin",
  },
  {
    title: "Friendly, Clear Communication",
    description: "We speak plain English, not tech jargon. You'll always understand what's happening with your IT and why it matters to your business.",
    icon: "MessageSquare",
  },
  {
    title: "Proven Track Record with Long-Term Clients",
    description: "Many of our clients have been with us for over a decade. That's the kind of trust and reliability you can count on.",
    icon: "TrendingUp",
  },
  {
    title: "Enterprise Expertise, Small Business Pricing",
    description: "Get the same level of IT expertise that large corporations enjoy, but at pricing designed for small and medium businesses.",
    icon: "BadgeDollarSign",
  },
  {
    title: "Proactive, Not Reactive",
    description: "We don't just wait for things to break. Our proactive monitoring and maintenance prevents issues before they impact your business.",
    icon: "Shield",
  },
];

export const faqItems = [
  {
    question: "What does managed IT support include?",
    answer: "Our managed IT support includes 24/7 system monitoring, helpdesk support (remote and on-site), proactive maintenance, security patching, vendor management, and monthly reporting. We act as your complete IT department.",
  },
  {
    question: "How quickly do you respond to support requests?",
    answer: "We respond to support requests as quickly as possible during business hours, and critical issues are always prioritised. Agreed response times can be built into your support plan.",
  },
  {
    question: "Do you offer support for businesses outside Sydney?",
    answer: "Yes! While we're based in Sydney, we support businesses across Australia through our remote support capabilities. For on-site needs outside Sydney, we have a network of trusted partners.",
  },
  {
    question: "What makes you different from larger MSPs?",
    answer: "Unlike large MSPs, you won't be passed between departments or treated as a ticket number. We provide personalised service with a dedicated account manager who knows your business, at competitive pricing.",
  },
  {
    question: "Can you work with our existing IT setup?",
    answer: "Absolutely. We work with your existing infrastructure. We'll conduct an assessment, identify improvements, and create a roadmap to optimise your IT environment over time \u2014 without unnecessary disruption.",
  },
  {
    question: "How does your pricing work?",
    answer: "We offer fixed monthly pricing based on your number of users and services needed. This gives you predictable IT costs with no surprise bills. Contact us for a free, no-obligation quote.",
  },
];

export const navigationLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  {
    label: "Services",
    path: "/services",
    children: services.map(s => ({ label: s.title, path: `/services/${s.id}` })),
  },
  {
    label: "Industries",
    path: "/industries",
    children: industries.map(i => ({ label: i.title, path: `/industries/${i.id}` })),
  },
  { label: "Why FlexiTech", path: "/why-flexitech" },
  { label: "Contact", path: "/contact" },
];
